import React, { useEffect } from "react";
import { FloatingPortal } from "@floating-ui/react";
import "./style.scss";

export default function Tooltip({
  isOpen,
  setIsOpen,
  children,
  refs,
  floatingStyles,
  getFloatingProps,
}) {
  useEffect(() => {
    if (isOpen) {
      const timeoutId = setTimeout(() => {
        setIsOpen(false);
      }, 3000);

      return () => {
        clearTimeout(timeoutId);
      };
    }
  }, [isOpen, setIsOpen]);

  return (
    <div className="tooltip-insider-component">
      <FloatingPortal>
        {isOpen && (
          <div
            className="tooltip-insider-component-inner"
            ref={refs.setFloating}
            style={floatingStyles}
            {...getFloatingProps()}
          >
            <div className="content-tooltip">
              <>{children}</>
              <button onClick={() => setIsOpen(false)} className="close-button">
                <span></span>
                <span></span>
              </button>
            </div>
          </div>
        )}
      </FloatingPortal>
    </div>
  );
}
